import { DetectedObjectTypes } from 'types';

export default (dataExtractionDictionary: Record<number, string>): DetectedObjectTypes => {
  const formattedDataExtractionDefinitions: Record<string, string> = {};

  Object.keys(dataExtractionDictionary).forEach((key, index) => {
    formattedDataExtractionDefinitions[key] = formatValue(dataExtractionDictionary[index]);
  });

  const detectedObjectTypes: DetectedObjectTypes = {
    detectedObjectTypes: formattedDataExtractionDefinitions,
  };

  return detectedObjectTypes;
};

const formatValue = (text: string): string => {
  const specialCasing = ['BSN', 'IBAN', 'LLM', 'KVK'];
  const splitRegex = /([a-z])([A-Z])/g;
  let formattedText = text.replace(splitRegex, '$1 $2').toLowerCase();

  specialCasing.forEach((exception) => {
    const regex = new RegExp(`\\b${exception.toLowerCase()}\\b`, 'g');
    formattedText = formattedText.replace(regex, exception);
  });
  formattedText = formattedText.charAt(0).toUpperCase() + formattedText.slice(1);
  return formattedText;
};
